const InputError = ({ field, errors }) => {
  return errors && errors[field] ? (
    <p className="error my-1 text-sm text-red-400">{errors[field]}</p>
  ) : null;
};

export default InputError;
